/**
 * `/api/boards` — every call the board module makes, through core's `apiFetch`.
 */
import type {
  BoardListResponse,
  BoardResponse,
  ListQueryParams,
  OwnBoardsResponse,
  SetBoardRequest,
} from '@forsys/shared';
import { apiFetch, query } from '../../api/client';

/** The boards on the caller's dashboard. A session is enough. */
export function listOwnBoards(): Promise<OwnBoardsResponse> {
  return apiFetch<OwnBoardsResponse>('/boards/mine');
}

/** The boards the caller may edit, with or without text. Needs `board.update`. */
export function listBoards(params: ListQueryParams = {}): Promise<BoardListResponse> {
  return apiFetch<BoardListResponse>(`/boards${query({ ...params })}`);
}

/** Empty text removes the board. */
export function setBoard(groupId: number, text: string): Promise<BoardResponse> {
  const request: SetBoardRequest = { text };
  return apiFetch<BoardResponse>(`/boards/${groupId}`, { method: 'PUT', json: request });
}
